export const DEFAULT_BLUE = '#239ed8';

export const DEFAULT_FILTERS_DEBOUNCE_TIMEOUT_IN_MS = 400;

// Gantt chart's configuration
export const STATIC_ELEMENT_HEIGHT = 44;
export const STATIC_POINT_HEIGHT = 36;

export const TOOLTIP_PADDING_SIZE = 30;
